import MobileDetect from 'mobile-detect';

export const getDeviceType = (userAgent) => {
  const md = new MobileDetect(userAgent);
  if (md.tablet()) {
    return 'tablet';
  }
  if (md.mobile()) {
    return 'mobile';
  }
  return 'desktop';
};
